import { render, staticRenderFns } from "./Gadget.vue?vue&type=template&id=4721dda6&scoped=true&"
import script from "./Gadget.vue?vue&type=script&lang=js&"
export * from "./Gadget.vue?vue&type=script&lang=js&"
import style0 from "./Gadget.vue?vue&type=style&index=0&id=4721dda6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721dda6",
  null
  
)

export default component.exports